import { v4 as uuidv4 } from 'uuid';
import { createSlice, current } from '@reduxjs/toolkit';
import { produce } from 'immer';

export const flexRegexConfig = {
  'flex': { 'property-name': 'flex', 'regex': /display\s*:\s*flex\s*[^;]*;/, 'defaultValue': false },
  'alignContent': { 'property-name': 'align-content', 'regex': /align-content\s*:\s*[^;]*;/, 'defaultValue': 'normal' },
  'alignItems': { 'property-name': 'align-items', 'regex': /align-items\s*:\s*[^;]*;/, 'defaultValue': 'normal' },
  'flexDirection': { 'property-name': 'flex-direction', 'regex': /flex-direction\s*:\s*[^;]*;/, 'defaultValue': 'row' },
  'flexWrap': { 'property-name': 'flex-wrap', 'regex': /flex-wrap\s*:\s*[^;]*;/, 'defaultValue': 'nowrap' },
  'justifyContent': { 'property-name': 'justify-content', 'regex': /justify-content\s*:\s*[^;]*;/, 'defaultValue': 'normal' },
  'flexGrow': { 'property-name': 'flex-grow', 'regex': /flex-grow\s*:\s*[^;]*;/, 'defaultValue': 0 },
  'flexShrink': { 'property-name': 'flex-shrink', 'regex': /flex-shrink\s*:\s*[^;]*;/, 'defaultValue': 1 },
  'flexBasis': { 'property-name': 'flex-basis', 'regex': /flex-basis\s*:\s*[^;]*;/, 'defaultValue': 'auto' },
  'order': { 'property-name': 'order', 'regex': /order\s*:\s*[^;]*;/, 'defaultValue': 1 },
  'alignSelf': { 'property-name': 'align-self', 'regex': /align-self\s*:\s*[^;]*;/, 'defaultValue': 'auto' },
  'marginTop': { 'property-name': 'margin-top', 'regex': /margin-top\s*:\s*[^;]*;/, 'defaultValue': '' },
  'marginRight': { 'property-name': 'margin-right', 'regex': /margin-right\s*:\s*[^;]*;/, 'defaultValue': '' },
  'marginBottom': { 'property-name': 'margin-bottom', 'regex': /margin-bottom\s*:\s*[^;]*;/, 'defaultValue': '' },
  'marginLeft': { 'property-name': 'margin-left', 'regex': /margin-left\s*:\s*[^;]*;/, 'defaultValue': '' },
  'paddingTop': { 'property-name': 'padding-top', 'regex': /padding-top\s*:\s*[^;]*;/, 'defaultValue': '' },
  'paddingRight': { 'property-name': 'padding-right', 'regex': /padding-right\s*:\s*[^;]*;/, 'defaultValue': '' },
  'paddingBottom': { 'property-name': 'padding-bottom', 'regex': /padding-bottom\s*:\s*[^;]*;/, 'defaultValue': '' },
  'paddingLeft': { 'property-name': 'padding-left', 'regex': /padding-left\s*:\s*[^;]*;/, 'defaultValue': '' },
  'fontSize': { 'property-name': 'font-size', 'regex': /font-size\s*:\s*[^;]*;/, 'defaultValue': '' },
  'fontWeight': { 'property-name': 'font-weight', 'regex': /font-weight\s*:\s*[^;]*;/, 'defaultValue': '' },
  'color': { 'property-name': 'color', 'regex': /(?<![\w-])color\s*:\s*[^;]*;/, 'defaultValue': '' },
  'textAlign': { 'property-name': 'text-align', 'regex': /text-align\s*:\s*[^;]*;/, 'defaultValue': '' },
  'lineHeight': { 'property-name': 'line-height', 'regex': /line-height\s*:\s*[^;]*;/, 'defaultValue': '' },
  'letterSpacing': { 'property-name': 'letter-spacing', 'regex': /letter-spacing\s*:\s*[^;]*;/, 'defaultValue': '' },
  'borderRadius': { 'property-name': 'border-radius', 'regex': /border-radius\s*:\s*[^;]*;/, 'defaultValue': '' },
  'borderWidth': { 'property-name': 'border-width', 'regex': /border-width\s*:\s*[^;]*;/, 'defaultValue': '' },
  'borderStyle': { 'property-name': 'border-style', 'regex': /border-style\s*:\s*[^;]*;/, 'defaultValue': '' },
  'borderColor': { 'property-name': 'border-color', 'regex': /border-color\s*:\s*[^;]*;/, 'defaultValue': '' },
  'boxShadow': { 'property-name': 'box-shadow', 'regex': /(?<![\w-])box-shadow\s*:\s*[^;]*;/, 'defaultValue': '' },
  'textShadow': { 'property-name': 'text-shadow', 'regex': /(?<![\w-])text-shadow\s*:\s*[^;]*;/, 'defaultValue': '' },
  'width': { 'property-name': 'width', 'regex': /(?<![\w-])width\s*:\s*[^;]*;/, 'defaultValue': '' },
  'height': { 'property-name': 'height', 'regex': /(?<![\w-])height\s*:\s*[^;]*;/, 'defaultValue': '' },
  'maxWidth': { 'property-name': 'max-width', 'regex': /max-width\s*:\s*[^;]*;/, 'defaultValue': '' },
  'maxHeight': { 'property-name': 'max-height', 'regex': /max-height\s*:\s*[^;]*;/, 'defaultValue': '' },
  'minWidth': { 'property-name': 'min-width', 'regex': /min-width\s*:\s*[^;]*;/, 'defaultValue': '' },
  'minHeight': { 'property-name': 'min-height', 'regex': /min-height\s*:\s*[^;]*;/, 'defaultValue': '' },
  'overflow': { 'property-name': 'overflow', 'regex': /overflow\s*:\s*[^;]*;/, 'defaultValue': '' },
  'overflowX': { 'property-name': 'overflow-x', 'regex': /overflow-x\s*:\s*[^;]*;/, 'defaultValue': '' },
  'overflowY': { 'property-name': 'overflow-y', 'regex': /overflow-y\s*:\s*[^;]*;/, 'defaultValue': '' },
  'backgroundColor': { 'property-name': 'background-color', 'regex': /background-color\s*:\s*[^;]*;/, 'defaultValue': '' },
  'backgroundImage': { 'property-name': 'background-image', 'regex': /background-image\s*:\s*[^;]*;/, 'defaultValue': '' },
  'opacity': { 'property-name': 'opacity', 'regex': /(?<![\w-])opacity\s*:\s*[^;]*;/, 'defaultValue': '' },
}

const initialState = {
  templates: [
    {
      "id": uuidv4(),
      "domId": "application",
      "type": "app",
      "tagName": "app",
      "attributes": {},
      "children": [],
      "explain": "アプリケーション",
    },
  ],
  trashbox: [

  ],
  forceReload: false,
};

function findAndRemoveElement(elements, srcId) {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].id === srcId) {
      const [removed] = elements.splice(i, 1);
      return removed;
    }
    if (elements[i].children) {
      const found = findAndRemoveElement(elements[i].children, srcId);
      if (found) return found;
    }
  }
  return null;
}

/**
 * ツリー構造のディープサニタイズ関数
 * どの階層の要素であっても、必ず attributes (オブジェクト) と children (配列) を持つことを保証します。
 */
const sanitizeNodeDeep = (node) => {
  if (!node || typeof node !== 'object') return null;

  // attributes がオブジェクトであることを保証
  const attributes = (node.attributes && typeof node.attributes === 'object' && !Array.isArray(node.attributes))
    ? node.attributes
    : {};

  // children が配列であることを保証し、再帰的に浄化
  const children = Array.isArray(node.children)
    ? node.children.map(sanitizeNodeDeep).filter(Boolean)
    : [];

  return {
    ...node,
    attributes,
    children
  };
};

const templateJsonSlice = createSlice({
  name: 'templateJson',
  initialState,
  reducers: {
    reload(state, action) {
      state.templates = [...state.templates];
      state.forceReload = true;
    },
    loadTemplateJson(state, action) {
      const payload = action.payload;
      // 1. ペイロード自体のチェック
      if (!payload || typeof payload !== 'object') return;

      // 2. ルートプロパティのマージ
      Object.keys(initialState).forEach(key => {
        state[key] = payload[key] !== undefined ? payload[key] : initialState[key];
      });

      // 3. 配列の確保 (nullなら空配列へ)
      let templates = Array.isArray(state.templates) ? state.templates : [];
      let trashbox = Array.isArray(state.trashbox) ? state.trashbox : [];

      // 4. ルート配列のサニタイズと NULL除去
      // map の結果には null が含まれる可能性があるため、必ず filter(Boolean) で除去する
      templates = templates.map(sanitizeNodeDeep).filter(Boolean);
      trashbox = trashbox.map(sanitizeNodeDeep).filter(Boolean);

      // 5. 安全なデータに対して ID採番 を実行
      state.templates = attachIds(templates, templates, trashbox);
      state.trashbox = trashbox;
    },
    addTemplate(state, action) {
      let { newTemplate, forceReload = true } = action.payload;

      // 追加する要素をディープサニタイズし、構造の安全性を保証する
      newTemplate = sanitizeNodeDeep(newTemplate);
      if (!newTemplate) return;

      let updatedStructure = [...state.templates];
      updatedStructure.push(newTemplate);
      updatedStructure = attachIds(updatedStructure, updatedStructure, state.trashbox);
      state.templates = updatedStructure;

      state.forceReload = forceReload;
    },
    /**
     * trashboxに移動する
     * @param {*} state 
     * @param {*} action 
     */
    moveToTrashbox(state, action) {
      let { targetId, forceReload = true } = action.payload;
      const target = findElementById(state, targetId);
      //trashboxの先頭に追加
      state.trashbox.unshift(target);
      if (target) {
        state.templates = deleteElementFunc(state.templates, targetId);
      }

      state.forceReload = forceReload;
    },
    /**
     * trashboxから元に戻す
     * @param {*} state 
     * @param {*} action 
     */
    moveToTemplate(state, action) {
      let { targetId, forceReload = true } = action.payload;
      const target = findElementById(state, targetId);
      //Templateに追加
      state.templates.push(target);
      if (target) {
        state.trashbox = deleteElementFunc(state.trashbox, targetId);
      }

      state.forceReload = forceReload;
    },

    /**
     * ゴミ箱に入れずに完全に削除する
     */
    deleteElementPermanently(state, action) {
      let { targetId, forceReload = true } = action.payload;
      const target = findElementById(state, targetId);
      if (target) {
        state.templates = deleteElementFunc(state.templates, targetId);
      }

      state.forceReload = forceReload;
    },

    //trushboxを空にする
    clearTrashbox(state, action) {
      state.trashbox = [];
      state.forceReload = false;
    },
    /**
     * エレメントのコピー
     * originIdをprevElementIdの次の兄弟要素としてコピーする
     * コピーした要素のidとdomIdは振りなおす
     * @param {*} state 
     * @param {payload : {originId, prevElementId}} action 
     */
    copyElement(state, action) {
      let { originId, prevElementId, forceReload = true } = action.payload;

      function getCopyElement(originElement) {
        let element = { ...originElement }
        if (element.children && element.children.length > 0) {
          let children = [];
          element.children.forEach(child => {
            children.push(getCopyElement(child));
          });
          element.children = children;
        }

        if (element.attributes) {
          element.attributes = { ...element.attributes };
        }

        return element
      }
      /**
       * elementのidとdomIdとtemplate-idにnullを設定する
       * element.childrenを再帰処理し、idとdomIdにnullを設定する
       * 
       * @param {*} element 
       */
      function setUndefinedId(element) {
        element.id = undefined;
        element.domId = undefined;

        //element.attributes['template-id']にundefinedを設定
        if (element.attributes['template-id']) {
          element.attributes['template-id'] = undefined;
        }

        //element.childrenを再帰処理
        if (element.children && element.children.length > 0) {
          element.children.forEach(child => {
            setUndefinedId(child);
          });
        }
      }

      function insertRecursive(elements) {
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].id === prevElementId) {
            // prevElementId に対応する要素を見つけた場合、その次の兄弟として新しい要素を挿入
            elements.splice(i + 1, 0, copyElement);
            return true; // 挿入が完了したことを示すために true を返す
          }
          if (elements[i].children && elements[i].children.length > 0) {
            if (insertRecursive(elements[i].children)) {
              return true; // 再帰呼び出しの結果、挿入が完了した場合は true を返す
            }
          }
        }
        return false; // 要素が見つからない場合は false を返す
      }

      let copyElement = getCopyElement(findElementById(state, originId));
      setUndefinedId(copyElement);
      state.templates = produce(state.templates, draft => {
        insertRecursive(draft);
      });
      state.templates = attachIds(state.templates, state.templates, state.trashbox);

      state.forceReload = forceReload;
    },
    insertAfter(state, action) {
      let { targetId, newElement, forceReload = true } = action.payload;

      // 追加する要素をディープサニタイズ
      newElement = sanitizeNodeDeep(newElement);
      if (!newElement) return;

      function insertRecursive(elements) {
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].id === targetId) {
            elements.splice(i + 1, 0, newElement);
            return true;
          }
          if (elements[i].children && elements[i].children.length > 0) {
            if (insertRecursive(elements[i].children)) {
              return true;
            }
          }
        }
        return false;
      }

      state.templates = produce(state.templates, draft => {
        insertRecursive(draft);
      });
      state.templates = attachIds(state.templates, state.templates, state.trashbox);

      state.forceReload = forceReload;
    },
    insertAsChild(state, action) {
      let { targetId, newElement, forceReload = true } = action.payload;

      // 追加する要素をディープサニタイズ
      newElement = sanitizeNodeDeep(newElement);
      if (!newElement) return;

      const parentElement = findElementById({ templates: state.templates, trashbox: state.trashbox }, targetId);
      if (parentElement) {
        if (!parentElement.children) {
          parentElement.children = [];
        }
        parentElement.children.unshift(newElement);
      }
      state.templates = attachIds(state.templates, state.templates, state.trashbox);

      state.forceReload = forceReload;
    },
    insertAsLastChild(state, action) {
      let { targetId, newElement, forceReload = true } = action.payload;

      // 追加する要素をディープサニタイズ
      newElement = sanitizeNodeDeep(newElement);
      if (!newElement) return;

      const parentElement = findElementById({ templates: state.templates, trashbox: state.trashbox }, targetId);
      if (parentElement) {
        if (!parentElement.children) {
          parentElement.children = [];
        }
        parentElement.children.push(newElement);
      }
      state.templates = attachIds(state.templates, state.templates, state.trashbox);

      state.forceReload = forceReload;
    },
    moveAfter(state, action) {
      let { destId, srcId, forceReload = true } = action.payload;
      // srcIdに対応する要素をdestIdに対応する要素の後ろに移動

      let srcParent = null; // srcIdに対応する要素
      let destElement = null; // destIdに対応する要素
      let srcIndex = -1; // srcIdに対応する要素のインデックス
      let destIndex = -1; // destIdに対応する要素のインデックス

      function moveRecursive(elements) {

        for (let i = 0; i < elements.length; i++) {
          if (elements[i].id === srcId) {
            srcIndex = i;
            srcParent = elements;
          }
          if (elements[i].id === destId) {
            destIndex = i;
            destElement = elements;
          }
          if (elements[i].children && elements[i].children.length > 0) {
            const result = moveRecursive(elements[i].children);
            if (result) {
              return result;
            }
          }
        }

        if (srcIndex !== -1 && destIndex !== -1 && srcParent && destElement) {
          // srcIdとdestIdに対応する要素が見つかった場合
          const srcElement = srcParent[srcIndex]; // srcIdに対応する要素
          srcParent.splice(srcIndex, 1); // srcIdに対応する要素を削除
          if (srcParent === destElement) {
            // 同じ親要素に属している場合
            if (srcIndex < destIndex) {
              // 上から下に移動する場合
              destElement.splice(destIndex, 0, srcElement); // destIdに対応する要素の前にsrcIdに対応する要素を挿入
            } else {
              // 下から上に移動する場合
              destElement.splice(destIndex + 1, 0, srcElement); // destIdに対応する要素の後ろにsrcIdに対応する要素を挿入
            }
          } else {
            // 異なる親要素に属している場合
            destElement.splice(destIndex + 1, 0, srcElement); // destIdに対応する要素の後ろにsrcIdに対応する要素を挿入
          }
          return true; // 移動が完了したことを示すために true を返す
        }

        return false; // 要素が見つからない場合は false を返す
      }

      state.templates = produce(state.templates, draft => {
        moveRecursive(draft);
      });

      state.forceReload = forceReload;
    },
    moveAsChild(state, action) {
      let { destId, srcId, forceReload = true } = action.payload;
      // srcIdに対応する要素をdestIdに対応する要素の子要素として移動

      let srcParent = null; // srcIdに対応する要素の親要素
      let destElement = null; // destIdに対応する要素
      let srcIndex = -1; // srcIdに対応する要素のインデックス

      function moveRecursive(elements) {

        for (let i = 0; i < elements.length; i++) {
          if (elements[i].id === srcId) {
            srcIndex = i;
            srcParent = elements;
          }
          if (elements[i].id === destId) {
            destElement = elements[i];
          }
          if (elements[i].children && elements[i].children.length > 0) {
            const result = moveRecursive(elements[i].children);
            if (result) {
              return result;
            }
          }
        }

        if (srcIndex !== -1 && destElement && srcParent) {
          // srcIdとdestIdに対応する要素が見つかった場合
          const srcElement = srcParent[srcIndex]; // srcIdに対応する要素
          srcParent.splice(srcIndex, 1); // srcIdに対応する要素を削除
          if (!destElement.children) {
            destElement.children = [];
          }
          destElement.children.unshift(srcElement); // destIdに対応する要素の子要素としてsrcIdに対応する要素を挿入
          return true; // 移動が完了したことを示すために true を返す
        }

        return false; // 要素が見つからない場合は false を返す
      }

      state.templates = produce(state.templates, draft => {
        moveRecursive(draft);
      });

      state.forceReload = forceReload;
    },
    // 末尾の子要素として移動するリデューサー
    moveAsLastChild(state, action) {
      let { destId, srcId, forceReload = true } = action.payload;

      state.templates = produce(state.templates, draft => {
        const srcElement = findAndRemoveElement(draft, srcId);
        if (!srcElement) return;

        const destElement = findElementById({ templates: draft, trashbox: [] }, destId);
        if (!destElement) return;

        if (!destElement.children) {
          destElement.children = [];
        }
        destElement.children.push(srcElement);
      });

      state.forceReload = forceReload;
    },
    // Styleの更新
    updateElementStyle(state, action) {
      let { id, newStyle } = action.payload;
      let styleActuallyChanged = false; // スタイルが実際に変更されたかどうかのフラグ

      function updateStyleRecursive(elements) {
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].id === id) {
            // 現在のスタイルを取得 (attributes.styleが存在しない場合は空文字列として扱う)
            const currentStyle = elements[i].attributes?.style || '';

            // 比較のためにスタイル文字列を正規化
            const normalizedCurrentStyle = normalizeStyle(currentStyle);
            const normalizedNewStyle = normalizeStyle(newStyle);

            // 正規化されたスタイルが異なる場合のみ更新
            if (normalizedCurrentStyle !== normalizedNewStyle) {
              styleActuallyChanged = true; // 変更があったことを記録
              elements[i] = {
                ...elements[i],
                attributes: {
                  ...elements[i].attributes,
                  style: newStyle
                }
              };
            }
            return true; // 要素が見つかったので更新処理完了（スタイルが変更されなくても見つかった事実は変わらない）
          }
          if (elements[i].children && elements[i].children.length > 0) {
            if (updateStyleRecursive(elements[i].children)) {
              return true; // 子要素で更新が完了した
            }
          }
        }
        return false; // 要素が見つからなかった
      }

      state.templates = produce(state.templates, draft => {
        updateStyleRecursive(draft);
      });

      // スタイルが実際に変更された場合のみforceReloadをtrueにする
      state.forceReload = styleActuallyChanged;
    },
    // 属性の更新
    updateElementAttribute(state, action) {
      let { elementId, inputType, attributeType, newValue, forceReload = true } = action.payload;
      state.templates = produce([...state.templates], (draft) => {
        function updateElementRecursive(elements) {
          for (let i = 0; i < elements.length; i++) {
            if (elements[i].id === elementId) {
              const style = elements[i].attributes.style;
              switch (attributeType) {
                case 'tagName':
                  elements[i].tagName = newValue;
                  break;
                case 'domId':
                  elements[i].domId = newValue;
                  break;
                case 'text':
                  elements[i].text = newValue;
                  break;
                case 'expand':
                  elements[i].expand = newValue;
                  forceReload = false;
                  break;
                case 'explain':
                  elements[i].explain = newValue;
                  break;
                case 'style-flex':
                  if (style) {
                    if (newValue.flex === false) {
                      // styleがあってさらにdisplay:flexがある場合は、display:flexとそれに連なる設定を削除する
                      let styleArray = style.split('\n');

                      newValue.flexDirection = flexRegexConfig.flexDirection.defaultValue;
                      newValue.flexWrap = flexRegexConfig.flexWrap.defaultValue;
                      newValue.alignContent = flexRegexConfig.alignContent.defaultValue;
                      newValue.justifyContent = flexRegexConfig.justifyContent.defaultValue;
                      newValue.alignItems = flexRegexConfig.alignItems.defaultValue;

                      removeFlexStyle(styleArray);
                      updateStyleProperty(styleArray, 'flexDirection', newValue, 'row');
                      updateStyleProperty(styleArray, 'flexWrap', newValue, 'nowrap');
                      updateStyleProperty(styleArray, 'alignContent', newValue, 'normal');
                      updateStyleProperty(styleArray, 'justifyContent', newValue, 'normal');
                      updateStyleProperty(styleArray, 'alignItems', newValue, 'normal');
                      //elements[i].attributes.style = styleArray.join('\n');
                      elements[i].attributes = {
                        ...elements[i].attributes,
                        style: styleArray.join('\n'),
                      };
                    } else {
                      // styleがあってdisplay:flexが追加される場合は
                      let styleArray = style.split('\n');
                      addFlexStyle(styleArray, newValue);
                      updateStyleProperty(styleArray, 'flexDirection', newValue, 'row');
                      updateStyleProperty(styleArray, 'flexWrap', newValue, 'nowrap');
                      updateStyleProperty(styleArray, 'alignContent', newValue, 'normal');
                      updateStyleProperty(styleArray, 'justifyContent', newValue, 'normal');
                      updateStyleProperty(styleArray, 'alignItems', newValue, 'normal');
                      //elements[i].attributes.style = styleArray.join('\n');
                      elements[i].attributes = {
                        ...elements[i].attributes,
                        style: styleArray.join('\n'),
                      };
                    }
                  } else {
                    //styleがなければ、styleを追加した上でdisplay:flexとそれに連なる設定を追加する
                    let styleArray = `\n`.split('\n');
                    addFlexStyle(styleArray, newValue);
                    updateStyleProperty(styleArray, 'flexDirection', newValue, 'row');
                    updateStyleProperty(styleArray, 'flexWrap', newValue, 'nowrap');
                    updateStyleProperty(styleArray, 'alignContent', newValue, 'normal');
                    updateStyleProperty(styleArray, 'justifyContent', newValue, 'normal');
                    updateStyleProperty(styleArray, 'alignItems', newValue, 'normal');
                    //elements[i].attributes.style = styleArray.join('\n');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n'),
                    };
                  }
                  break;
                case 'style-flexitem':
                case 'style-flex-item':
                  if (style) {
                    let styleArray = style.split('\n');
                    updateStyleProperty(styleArray, 'flexGrow', newValue, 'row');
                    updateStyleProperty(styleArray, 'flexShrink', newValue, 'nowrap');
                    updateStyleProperty(styleArray, 'flexBasis', newValue, 'normal');
                    updateStyleProperty(styleArray, 'order', newValue, 'normal');
                    updateStyleProperty(styleArray, 'alignSelf', newValue, 'normal');
                    //elements[i].attributes.style = styleArray.join('\n');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n'),
                    };
                  } else {
                    //styleがなければ、styleを追加した上で設定を追加する
                    let styleArray = `\n  `.split('\n');
                    updateStyleProperty(styleArray, 'flexGrow', newValue, 'row');
                    updateStyleProperty(styleArray, 'flexShrink', newValue, 'nowrap');
                    updateStyleProperty(styleArray, 'flexBasis', newValue, 'normal');
                    updateStyleProperty(styleArray, 'order', newValue, 'normal');
                    updateStyleProperty(styleArray, 'alignSelf', newValue, 'normal');
                    //elements[i].attributes.style = styleArray.join('\n');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n'),
                    };
                  }
                  break;
                case 'style-shadow':
                  if (style) {
                    let styleArray = style.split('\n');
                    updateStyleProperty(styleArray, 'boxShadow', newValue, '');
                    updateStyleProperty(styleArray, 'textShadow', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  } else {
                    let styleArray = `\n  `.split('\n');
                    updateStyleProperty(styleArray, 'boxShadow', newValue, '');
                    updateStyleProperty(styleArray, 'textShadow', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  }
                  break;
                case 'style-spacing':
                  if (style) {
                    let styleArray = style.split('\n');
                    updateStyleProperty(styleArray, 'marginTop', newValue, '');
                    updateStyleProperty(styleArray, 'marginRight', newValue, '');
                    updateStyleProperty(styleArray, 'marginBottom', newValue, '');
                    updateStyleProperty(styleArray, 'marginLeft', newValue, '');
                    updateStyleProperty(styleArray, 'paddingTop', newValue, '');
                    updateStyleProperty(styleArray, 'paddingRight', newValue, '');
                    updateStyleProperty(styleArray, 'paddingBottom', newValue, '');
                    updateStyleProperty(styleArray, 'paddingLeft', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  } else {
                    let styleArray = `\n  `.split('\n');
                    updateStyleProperty(styleArray, 'marginTop', newValue, '');
                    updateStyleProperty(styleArray, 'marginRight', newValue, '');
                    updateStyleProperty(styleArray, 'marginBottom', newValue, '');
                    updateStyleProperty(styleArray, 'marginLeft', newValue, '');
                    updateStyleProperty(styleArray, 'paddingTop', newValue, '');
                    updateStyleProperty(styleArray, 'paddingRight', newValue, '');
                    updateStyleProperty(styleArray, 'paddingBottom', newValue, '');
                    updateStyleProperty(styleArray, 'paddingLeft', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  }
                  break;
                case 'style-typography':
                  if (style) {
                    let styleArray = style.split('\n');
                    updateStyleProperty(styleArray, 'fontSize', newValue, '');
                    updateStyleProperty(styleArray, 'fontWeight', newValue, '');
                    updateStyleProperty(styleArray, 'color', newValue, '');
                    updateStyleProperty(styleArray, 'textAlign', newValue, '');
                    updateStyleProperty(styleArray, 'lineHeight', newValue, '');
                    updateStyleProperty(styleArray, 'letterSpacing', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  } else {
                    let styleArray = `\n  `.split('\n');
                    updateStyleProperty(styleArray, 'fontSize', newValue, '');
                    updateStyleProperty(styleArray, 'fontWeight', newValue, '');
                    updateStyleProperty(styleArray, 'color', newValue, '');
                    updateStyleProperty(styleArray, 'textAlign', newValue, '');
                    updateStyleProperty(styleArray, 'lineHeight', newValue, '');
                    updateStyleProperty(styleArray, 'letterSpacing', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  }
                  break;
                case 'style-border':
                  if (style) {
                    let styleArray = style.split('\n');
                    updateStyleProperty(styleArray, 'borderRadius', newValue, '');
                    updateStyleProperty(styleArray, 'borderWidth', newValue, '');
                    updateStyleProperty(styleArray, 'borderStyle', newValue, '');
                    updateStyleProperty(styleArray, 'borderColor', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  } else {
                    let styleArray = `\n  `.split('\n');
                    updateStyleProperty(styleArray, 'borderRadius', newValue, '');
                    updateStyleProperty(styleArray, 'borderWidth', newValue, '');
                    updateStyleProperty(styleArray, 'borderStyle', newValue, '');
                    updateStyleProperty(styleArray, 'borderColor', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  }
                  break;
                case 'style-sizing':
                  if (style) {
                    let styleArray = style.split('\n');
                    updateStyleProperty(styleArray, 'width', newValue, '');
                    updateStyleProperty(styleArray, 'height', newValue, '');
                    updateStyleProperty(styleArray, 'maxWidth', newValue, '');
                    updateStyleProperty(styleArray, 'maxHeight', newValue, '');
                    updateStyleProperty(styleArray, 'minWidth', newValue, '');
                    updateStyleProperty(styleArray, 'minHeight', newValue, '');
                    updateStyleProperty(styleArray, 'overflow', newValue, '');
                    updateStyleProperty(styleArray, 'overflowX', newValue, '');
                    updateStyleProperty(styleArray, 'overflowY', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  } else {
                    let styleArray = `\n  `.split('\n');
                    updateStyleProperty(styleArray, 'width', newValue, '');
                    updateStyleProperty(styleArray, 'height', newValue, '');
                    updateStyleProperty(styleArray, 'maxWidth', newValue, '');
                    updateStyleProperty(styleArray, 'maxHeight', newValue, '');
                    updateStyleProperty(styleArray, 'minWidth', newValue, '');
                    updateStyleProperty(styleArray, 'minHeight', newValue, '');
                    updateStyleProperty(styleArray, 'overflow', newValue, '');
                    updateStyleProperty(styleArray, 'overflowX', newValue, '');
                    updateStyleProperty(styleArray, 'overflowY', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  }
                  break;
                case 'style-background':
                  if (style) {
                    let styleArray = style.split('\n');
                    updateStyleProperty(styleArray, 'backgroundColor', newValue, '');
                    updateStyleProperty(styleArray, 'backgroundImage', newValue, '');
                    updateStyleProperty(styleArray, 'opacity', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  } else {
                    let styleArray = `\n  `.split('\n');
                    updateStyleProperty(styleArray, 'backgroundColor', newValue, '');
                    updateStyleProperty(styleArray, 'backgroundImage', newValue, '');
                    updateStyleProperty(styleArray, 'opacity', newValue, '');
                    elements[i].attributes = {
                      ...elements[i].attributes,
                      style: styleArray.join('\n').trim(),
                    };
                  }
                  break;
                default:
                  // 1. 現在のattributesオブジェクトのコピーを作成する
                  const newAttributes = { ...elements[i].attributes };

                  // `tagName`や`domId`など、明示的にcaseで処理されていない属性は、
                  // すべて`attributes`オブジェクトを操作する
                  if (inputType === 'checkbox') {
                    if (newValue === true) {
                      // 2. コピーしたオブジェクトを変更する
                      newAttributes[attributeType] = true;
                    } else {
                      // 2. コピーしたオブジェクトからプロパティを削除する
                      delete newAttributes[attributeType];
                    }
                  } else if (inputType === 'select') {
                    if (newValue[0] === null || newValue[0] === undefined || newValue[0] === '') {
                      // 2. コピーしたオブジェクトからプロパティを削除する
                      delete newAttributes[attributeType];
                    } else {
                      // 2. コピーしたオブジェクトを変更する
                      newAttributes[attributeType] = newValue;
                    }
                  } else if (inputType === 'multiselect') {
                    if (newValue[0] === null || newValue[0] === undefined || newValue[0] === '') {
                      // 2. コピーしたオブジェクトからプロパティを削除する
                      delete newAttributes[attributeType];
                    } else {
                      // 2. コピーしたオブジェクトを変更する
                      newAttributes[attributeType] = newValue;
                    }
                  } else {
                    // newValueがnullまたはundefinedの場合は属性を削除し、それ以外の場合は設定します。
                    if (newValue === null || newValue === undefined) {
                      // 2. コピーしたオブジェクトからプロパティを削除する
                      delete newAttributes[attributeType];
                    } else {
                      // 2. コピーしたオブジェクトを変更する
                      newAttributes[attributeType] = newValue;
                    }
                  }
                  // 3. 変更が加えられた新しいオブジェクトで、ドラフトのattributesを置き換える
                  elements[i].attributes = newAttributes;
                  break; // defaultケースの終わりにbreakを追加
              }
              return true; // update completed
            }
            if (elements[i].children && elements[i].children.length > 0) {
              if (updateElementRecursive(elements[i].children)) {
                return true; // update completed in children
              }
            }
          }
          return false; // Element not found
        }

        updateElementRecursive(draft); // ここでdraftを引数として渡す
      });

      state.forceReload = forceReload;
    },
    /**
     * テンプレート内に存在する指定したタグの属性を削除する
     * テンプレート内でタグが複数存在する場合はその全てから属性が削除される
     * 
     * @param {*} state 
     * @param {*} action 
     */
    removeTagAttribute(state, action) {
      let { tagName, attributeKey, forceReload = true } = action.payload;

      //template.childrenを再帰で探す
      function searchAndDelete(element) {
        if (element.tagName === tagName) {
          switch (attributeKey) {
            case 'style-flex':
              removeFlexContainerStyles(element);
              break;
            case 'style-flexitem':
            case 'style-flex-item':
              removeFlexItemStyles(element);
              break;
            case 'style-spacing':
              removeSpacingStyles(element);
              break;
            case 'style-typography':
              removeTypographyStyles(element);
              break;
            case 'style-border':
              removeBorderStyles(element);
              break;
            case 'style-sizing':
              removeSizeStyles(element);
              break;
            case 'style-shadow':
              removeShadowStyles(element);
              break;
            case 'style-background':
              removeBackgroundStyles(element);
              break;
            case 'text':
              //textの場合はattributeではなくelementから直接削除する
              if (element['text'] !== undefined) {
                delete element['text'];
              }
              break;
            default:
              // 通常の属性の削除
              if (element.attributes && element.attributes[attributeKey] !== undefined) {
                delete element.attributes[attributeKey];
              }
          }
        }
        if (element.children && element.children.length > 0) {
          element.children.forEach(child => {
            searchAndDelete(child);
          });
        }
      }

      state.templates = produce(state.templates, draft => {
        draft.forEach(element => {
          searchAndDelete(element);
        });
      });

      state.forceReload = forceReload;
    },
    /**
     * 特定の要素から属性を削除する
     * 
     * @param {*} state 
     * @param {*} action 
     */
    removeElementAttribute(state, action) {
      let { elementId, attributeKey, forceReload = true } = action.payload;

      function searchAndDelete(elements) {
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          if (element.id === elementId) {
            if (attributeKey === 'text') {
              // 'text' プロパティの場合、要素の直下から削除
              if (element.text !== undefined) {
                delete element.text;
              }
            } else if (attributeKey === 'style-flex') {
              removeFlexContainerStyles(element);
            } else if (attributeKey === 'style-flexitem' || attributeKey === 'style-flex-item') {
              removeFlexItemStyles(element);
            } else {
              // それ以外の属性は 'attributes' オブジェクトから削除
              if (element.attributes[attributeKey] !== undefined) {
                delete element.attributes[attributeKey];
              }
            }
            return true; // 要素が見つかったのでループを終了
          }
          if (element.children && element.children.length > 0) {
            if (searchAndDelete(element.children)) {
              return true; // 子要素で見つかったのでループを終了
            }
          }
        }
        return false; // 要素が見つからなかった
      }

      state.templates = produce(state.templates, draft => {
        searchAndDelete(draft);
      });

      state.forceReload = forceReload;
    },
    /**
     * 展開・縮小の更新
     */
    updateExpand(state, action) {
      let { id, newExpand } = action.payload;

      function updateRecursive(elements) {
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].id === id) {
            elements[i].expand = newExpand;
            return true; // Style update completed
          }
          if (elements[i].children && elements[i].children.length > 0) {
            if (updateRecursive(elements[i].children)) {
              return true; // Style update completed in children
            }
          }
        }
        return false; // Element not found
      }

      state.templates = produce(state.templates, draft => {
        updateRecursive(draft);
      });
      state.forceReload = false;
    },

    /**
     * template-id 属性に基づいてテンプレートを削除する
     */
    deleteTemplateByAttributeId(state, action) {
      let { templateId, forceReload = true } = action.payload;

      const targetIndex = state.templates.findIndex(t =>
        t.attributes && t.attributes['template-id'] === templateId
      );

      if (targetIndex !== -1) {
        // trashbox.unshift(target) を削除し、単に削除のみ行う
        state.templates.splice(targetIndex, 1);
      }

      state.forceReload = forceReload;
    },

    /**
     * 指定したIDの要素の属性と子要素をすべて置換する（IDは維持）
     * ページの更新時にUUIDを変えないために使用
     */
    replaceTemplateChildren(state, action) {
      let { targetId, newElement, forceReload = true } = action.payload;

      state.templates = produce(state.templates, draft => {

        // ターゲット要素を検索するヘルパー（draft用）
        function findDraftElement(elements, id) {
          for (let i = 0; i < elements.length; i++) {
            if (elements[i].id === id) {
              return elements[i];
            }
            if (elements[i].children) {
              const found = findDraftElement(elements[i].children, id);
              if (found) return found;
            }
          }
          return null;
        }

        const targetElement = findDraftElement(draft, targetId);

        if (targetElement) {
          // ID以外のプロパティを上書き
          const oldId = targetElement.id;

          // 新しい要素の内容で上書き
          // newElementにはIDがない可能性があるため、システム仕様に従い attachIds でIDを付与する
          // ただし attachIds は配列を受け取るため、一時的に配列に入れて処理する
          const tempArray = [newElement];

          // attachIds は新しい配列を返すので、その結果を取得
          const processedArray = attachIds(draft, tempArray, state.trashbox);
          const processedNewElement = processedArray[0];

          // IDを元のものに戻す（ターゲット自体のIDは維持する必要があるため）
          processedNewElement.id = oldId;

          // draftオブジェクトの内容を書き換え
          // オブジェクトのプロパティを全削除してから新しいプロパティをコピー
          Object.keys(targetElement).forEach(key => delete targetElement[key]);
          Object.assign(targetElement, processedNewElement);
        }
      });

      state.forceReload = forceReload;
    },

    /**
     * UIの自動再描画を一時的に無効化する
     */
    setReloadOff(state) {
      state.forceReload = false;
    },
    /**
     * UIの再描画を強制する
     */
    setReloadOn(state) {
      state.forceReload = true;
    },
  }
});

function removeFlexStyle(styleArray) {
  const propertyConfig = flexRegexConfig['flex'];
  if (propertyConfig.regex.test(styleArray.join('\n'))) {
    let index = styleArray.findIndex(line => propertyConfig.regex.test(line));
    if (index !== -1) {
      let line = styleArray[index];
      let newLine = '';
      newLine = line.replace(propertyConfig.regex, '');
      if (newLine.trim().length === 0) {
        styleArray.splice(index, 1);
      } else {
        styleArray[index] = newLine;
      }
    }
  }
}

/**
 * 要素からFlexboxコンテナ関連のスタイルを削除します。
 * @param {object} element - スタイルを削除する要素。
 */
function removeFlexContainerStyles(element) {
  if (!element.attributes || !element.attributes.style) return;

  let styleArray = element.attributes.style.split('\n');
  const containerKeys = ['flex', 'alignContent', 'alignItems', 'flexDirection', 'flexWrap', 'justifyContent'];

  styleArray = styleArray.filter(line => {
    // いずれかのコンテナ用プロパティの正規表現に一致しない行のみを残す
    return !containerKeys.some(key => {
      const config = flexRegexConfig[key];
      return config && config.regex.test(line);
    });
  });

  element.attributes.style = styleArray.join('\n').trim();
  if (!element.attributes.style) {
    delete element.attributes.style;
  }
}

/**
 * 要素からFlexboxアイテム関連のスタイルを削除します。
 * @param {object} element - スタイルを削除する要素。
 */
function removeFlexItemStyles(element) {
  if (!element.attributes || !element.attributes.style) return;

  let styleArray = element.attributes.style.split('\n');
  const itemKeys = ['flexGrow', 'flexShrink', 'flexBasis', 'order', 'alignSelf'];

  styleArray = styleArray.filter(line => {
    // いずれかのアイテム用プロパティの正規表現に一致しない行のみを残す
    return !itemKeys.some(key => {
      const config = flexRegexConfig[key];
      return config && config.regex.test(line);
    });
  });

  element.attributes.style = styleArray.join('\n').trim();
  if (!element.attributes.style) {
    delete element.attributes.style;
  }
}

/**
 * 要素から余白（Margin/Padding）関連のスタイルを削除します。
 * @param {object} element - スタイルを削除する要素。
 */
function removeSpacingStyles(element) {
  if (!element.attributes || !element.attributes.style) return;

  let styleArray = element.attributes.style.split('\n');
  const spacingKeys = ['marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'];

  styleArray = styleArray.filter(line => {
    return !spacingKeys.some(key => {
      const config = flexRegexConfig[key];
      return config && config.regex.test(line);
    });
  });

  element.attributes.style = styleArray.join('\n').trim();
  if (!element.attributes.style) {
    delete element.attributes.style;
  }
}

/**
 * 要素からタイポグラフィ関連のスタイルを削除します。
 * @param {object} element - スタイルを削除する要素。
 */
function removeTypographyStyles(element) {
  if (!element.attributes || !element.attributes.style) return;

  let styleArray = element.attributes.style.split('\n');
  const typographyKeys = ['fontSize', 'fontWeight', 'color', 'textAlign', 'lineHeight', 'letterSpacing'];

  styleArray = styleArray.filter(line => {
    return !typographyKeys.some(key => {
      const config = flexRegexConfig[key];
      return config && config.regex.test(line);
    });
  });

  element.attributes.style = styleArray.join('\n').trim();
  if (!element.attributes.style) {
    delete element.attributes.style;
  }
}

/**
 * 要素からボーダー・角丸関連のスタイルを削除します。
 * @param {object} element - スタイルを削除する要素。
 */
function removeBorderStyles(element) {
  if (!element.attributes || !element.attributes.style) return;

  let styleArray = element.attributes.style.split('\n');
  const borderKeys = ['borderRadius', 'borderWidth', 'borderStyle', 'borderColor'];

  styleArray = styleArray.filter(line => {
    return !borderKeys.some(key => {
      const config = flexRegexConfig[key];
      return config && config.regex.test(line);
    });
  });

  element.attributes.style = styleArray.join('\n').trim();
  if (!element.attributes.style) {
    delete element.attributes.style;
  }
}

/**
 * 要素からシャドウ関連のスタイルを削除します。
 * @param {object} element - スタイルを削除する要素。
 */
function removeShadowStyles(element) {
  if (!element.attributes || !element.attributes.style) return;

  let styleArray = element.attributes.style.split('\n');
  const shadowKeys = ['boxShadow', 'textShadow'];

  styleArray = styleArray.filter(line => {
    return !shadowKeys.some(key => {
      const config = flexRegexConfig[key];
      return config && config.regex.test(line);
    });
  });

  element.attributes.style = styleArray.join('\n').trim();
  if (!element.attributes.style) {
    delete element.attributes.style;
  }
}

/**
 * 要素から背景・装飾関連のスタイルを削除します。
 * @param {object} element - スタイルを削除する要素。
 */
function removeBackgroundStyles(element) {
  if (!element.attributes || !element.attributes.style) return;

  let styleArray = element.attributes.style.split('\n');
  const backgroundKeys = ['backgroundColor', 'backgroundImage', 'opacity'];

  styleArray = styleArray.filter(line => {
    return !backgroundKeys.some(key => {
      const config = flexRegexConfig[key];
      return config && config.regex.test(line);
    });
  });

  element.attributes.style = styleArray.join('\n').trim();
  if (!element.attributes.style) {
    delete element.attributes.style;
  }
}

/**
 * 要素からサイズ・表示制御関連のスタイルを削除します。
 * @param {object} element - スタイルを削除する要素。
 */
function removeSizeStyles(element) {
  if (!element.attributes || !element.attributes.style) return;

  let styleArray = element.attributes.style.split('\n');
  const sizeKeys = ['width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'overflow', 'overflowX', 'overflowY'];

  styleArray = styleArray.filter(line => {
    return !sizeKeys.some(key => {
      const config = flexRegexConfig[key];
      return config && config.regex.test(line);
    });
  });

  element.attributes.style = styleArray.join('\n').trim();
  if (!element.attributes.style) {
    delete element.attributes.style;
  }
}

function deleteElementFunc(state, targetId) {
  function deleteRecursive(elements) {
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].id === targetId) {
        elements.splice(i, 1); // 要素を削除
        return true;
      }
      if (elements[i].children && elements[i].children.length > 0) {
        if (deleteRecursive(elements[i].children)) {
          return true;
        }
      }
    }
    return false;
  }

  return produce(state, draft => {
    deleteRecursive(draft);
  });
}

function addFlexStyle(styleArray, newValue) {
  const propertyConfig = flexRegexConfig['flex'];

  // styleがある場合、display:flexとそれに連なる設定を追加する
  if (!propertyConfig.regex.test(styleArray.join('\n'))) {
    //styleにdisplay:flex;を追加する
    styleArray.splice(styleArray.length - 1, 0, '    display: flex;');
  } else {
    //styleにdisplay:flex;があったら何もしない
  }
}

function updateStyleProperty(styleArray, property, value, defaultValue) {
  const propertyConfig = flexRegexConfig[property];
  const propValue = value[property];

  // 値が空、またはデフォルト値と等しい場合は出力しない（削除する）
  // 厳密等価(===)だと "1" と 1 が false になるので、Stringで合わせて比較する
  const isDefault = String(propValue) === String(defaultValue);
  const isEmpty = propValue === '' || propValue === null || propValue === undefined;

  if (!propertyConfig.regex.test(styleArray.join('\n'))) {
    //property:xxxx;を追加する
    if (!isEmpty && !isDefault) {
      styleArray.splice(styleArray.length - 1, 0, `    ${propertyConfig['property-name']}: ${propValue};`);
    }
  } else {
    //styleにproperty:xxxx;があったら、styleArrayから探して、その部分だけ文字列として削除して、新しく同じ場所に追加する
    let index = styleArray.findIndex(line => line.includes(propertyConfig['property-name']));
    if (index !== -1) {
      let line = styleArray[index];
      let newLine = '';
      if (isEmpty || isDefault) {
        newLine = line.replace(propertyConfig.regex, '');
      } else {
        newLine = line.replace(propertyConfig.regex, `${propertyConfig['property-name']}: ${propValue};`);
      }
      if (newLine.trim().length === 0) {
        styleArray.splice(index, 1);
      } else {
        styleArray[index] = newLine;
      }
    }
  }
}

const calculateMaxIdNum = (json, tagName, trushBoxStructure) => {
  // jsonの中から同じtagNameの要素を探す
  let elements = findElementsByTag(json, tagName);
  let trashElements = findElementsByTag(trushBoxStructure, tagName);
  trashElements = trashElements === undefined ? [] : trashElements;

  elements = elements.concat(trashElements);
  // 連番を決めるために既存のdomIdの最大値を求める
  let max = 0;
  // 正規表現を事前に定義
  const regex = new RegExp(`^${tagName}(\\d+)$`);

  for (let element of elements) {
    if (!element || element.domId == undefined) continue;
    // domIdがtagName+数字の形式であるかチェック
    let match = element.domId.match(regex);
    if (match) {
      // 数字部分を取り出して最大値と比較
      let num = parseInt(match[1], 10);
      if (num > max) {
        max = num;
      }
    }
  }
  return max;
}

export const findElementById = (state, targetId) => {
  // 配列から要素を探すための再帰的なヘルパー関数
  function findElement(arr, id) {
    for (const key in arr) {
      const item = arr[key];
      if (item.id === id) {
        return item;
      }
      if (item.children) {
        const result = findElement(item.children, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // jsonDataの全てのtemplatesを探索
  for (const key in state.templates) {
    const template = state.templates[key];
    // targetIdを持つ要素を探す
    if (template.id === targetId) {
      return template;
    }
    const result = findElement(template.children, targetId);
    if (result) {
      return result;
    }
  }

  for (const key in state.trashbox) {
    const template = state.trashbox[key];
    // targetIdを持つ要素を探す
    if (template.id === targetId) {
      return template;
    }
    const result = findElement(template.children, targetId);
    if (result) {
      return result;
    }
  }

  // targetIdが見つからない場合はnullを返す
  return null;
};


export const findNextSibling = (state, targetId) => {
  // 配列から要素を探すための再帰的なヘルパー関数
  function findElement(arr, id) {
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      if (item.id === id) {
        // 次の要素が存在する場合、それを返す
        if (i < arr.length - 1) {
          return arr[i + 1];
        }
        // 次の要素が存在しない場合、nullを返す
        return null;
      }
      if (item.children) {
        const result = findElement(item.children, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // templateJson.templatesまたはtemplateJson.trashboxの中で、targetIdを持つテンプレートの兄弟を探す
  const searchInCollection = (collection) => {
    const keys = Object.keys(collection);
    for (let i = 0; i < keys.length; i++) {
      const template = collection[keys[i]];
      if (template.id === targetId) {
        // 次のテンプレートが存在する場合、それを返す
        if (i < keys.length - 1) {
          return collection[keys[i + 1]];
        }
        // 次のテンプレートが存在しない場合、nullを返す
        return null;
      }
      // targetIdを持つ要素を探す
      const result = findElement(template.children, targetId);
      if (result) {
        return result;
      }
    }
    return null;
  };

  // templatesとtrashboxの両方で探索
  let result = searchInCollection(state.templateJson.templates);
  if (result) return result;

  result = searchInCollection(state.templateJson.trashbox);
  return result;
};

export const findFirstChild = (state, targetId) => {
  // 配列から要素を探すための再帰的なヘルパー関数
  function findElement(arr, id) {
    for (const key in arr) {
      const item = arr[key];
      if (item.id === id) {
        // 子要素が存在する場合、最初の子要素を返す
        if (item.children && item.children.length > 0) {
          return item.children[0];
        }
        // 子要素が存在しない場合、nullを返す
        return null;
      }
      if (item.children) {
        const result = findElement(item.children, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // jsonDataの全てのtemplatesを探索
  for (const key in state.templateJson.templates) {
    const template = state.templateJson.templates[key];
    // targetIdを持つ要素を探す
    if (template.id === targetId) {
      // 子要素が存在する場合、最初の子要素を返す
      if (template.children && template.children.length > 0) {
        return template.children[0];
      }
      // 子要素が存在しない場合、nullを返す
      return null;
    }
    const result = findElement(template.children, targetId);
    if (result) {
      return result;
    }
  }

  for (const key in state.templateJson.trashbox) {
    const template = state.templateJson.trashbox[key];
    // targetIdを持つ要素を探す
    if (template.id === targetId) {
      // 子要素が存在する場合、最初の子要素を返す
      if (template.children && template.children.length > 0) {
        return template.children[0];
      }
      // 子要素が存在しない場合、nullを返す
      return null;
    }
    const result = findElement(template.children, targetId);
    if (result) {
      return result;
    }
  }

  // targetIdが見つからない場合はnullを返す
  return null;
};


/**
 * domIdを指定してエレメントを取得
 * 
 * @param {store.getState()} state 
 * @param {domId} targetId 
 * @returns 
 */
export const findElementByDomId = (state, targetId) => {
  // 配列から要素を探すための再帰的なヘルパー関数
  function findElement(item, domId) {
    //itemがarrayの場合
    if (Array.isArray(item)) {
      for (let i in item) {
        if (item[i].domId === domId) {
          return item[i];
        }
        if (item[i].children) {
          const result = findElement(item[i].children, domId);
          if (result) {
            return result;
          }
        }
      }
    } else {
      if (item.domId === domId) {
        return item;
      }
      if (item.children) {
        const result = findElement(item.children, domId);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // jsonDataの全てのtemplatesを探索
  for (const key in state.templates) {
    const template = state.templates[key];
    // targetIdを持つ要素を探す
    if (template.domId == targetId) {
      return template;
    }
    const result = findElement(template, targetId);
    if (result) {
      return result;
    }
  }

  for (const key in state.trashbox) {
    const template = state.trashbox[key];
    // targetIdを持つ要素を探す
    if (template.domId == targetId) {
      return template;
    }
    const result = findElement(template, targetId);
    if (result) {
      return result;
    }
  }

  // targetIdが見つからない場合はnullを返す
  return null;
};

/**
 * template-id属性を指定してエレメントを取得
 * 
 * @param {store.getState()} state 
 * @param {domId} targetId 
 * @returns 
 */
export const findElementByTemplateId = (state, targetId) => {
  // 配列から要素を探すための再帰的なヘルパー関数
  function findElement(item, templateId) {
    //itemがarrayの場合
    if (Array.isArray(item)) {
      for (let i in item) {
        if (item[i].attributes['template-id'] === templateId) {
          return item[i];
        }
        if (item[i].children) {
          const result = findElement(item[i].children, templateId);
          if (result) {
            return result;
          }
        }
      }
    } else {
      if (item.attributes['template-id'] === templateId) {
        return item;
      }
      if (item.children) {
        const result = findElement(item.children, templateId);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // jsonDataの全てのtemplatesを探索
  for (const key in state.templates) {
    const template = state.templates[key];
    // targetIdを持つ要素を探す
    if (template.attributes['template-id'] == targetId) {
      return template;
    }
    const result = findElement(template, targetId);
    if (result) {
      return result;
    }
  }

  for (const key in state.trashbox) {
    const template = state.trashbox[key];
    // targetIdを持つ要素を探す
    if (template.attributes['template-id'] == targetId) {
      return template;
    }
    const result = findElement(template, targetId);
    if (result) {
      return result;
    }
  }

  // targetIdが見つからない場合はnullを返す
  return null;
};




/**
 * 走査対象のIDの親要素を返す
 * 
 * @param {ReduxStoreのgetState().xxxx} state 
 * @param {走査対象のID} targetId 
 * @returns 親要素
 */
export const findParentById = (state, targetId) => {
  // 配列から要素を探すための再帰的なヘルパー関数
  function findElement(arr, id, parent) {
    for (const key in arr) {
      const item = arr[key];
      if (item.id === id) {
        return parent; // 見つかったら親要素を返す
      }
      if (item.children) {
        const result = findElement(item.children, id, item); // 親要素としてitemを渡す
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // jsonDataの全てのtemplatesを探索
  for (const key in state.templates) {
    const template = state.templates[key];
    // targetIdを持つ要素を探す
    if (template.id === targetId) {
      return null; // ルート要素なら親がないのでnullを返す
    }
    const result = findElement(template.children, targetId, template); // 親要素としてtemplateを渡す
    if (result) {
      return result;
    }
  }
};

/**
 * 走査対象のIDの一番トップの親要素を返す
 * 
 * @param {ReduxStoreのgetState().xxxx} state 
 * @param {走査対象のID} targetId 
 * @returns 一番トップの親要素
 */
export const findTopParentById = (state, targetId) => {
  // 配列から要素を探すための再帰的なヘルパー関数
  function findElement(arr, id, parent) {
    for (const key in arr) {
      const item = arr[key];
      if (item.id === id) {
        return parent; // 見つかったら親要素を返す
      }
      if (item.children) {
        const result = findElement(item.children, id, item); // 親要素としてitemを渡す
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // 指定したIDの一番トップの親要素を収集する再帰関数
  function findTopParent(state, id) {
    let currentId = id;
    let topParent = null;
    let parent = null;

    do {
      parent = findParentById(state, currentId);
      if (parent) {
        topParent = parent; // 一番トップの親要素を更新
        currentId = parent.id;
      }
    } while (parent);

    return topParent;
  }

  // 指定したIDの親要素を探す
  function findParentById(state, targetId) {
    for (const key in state.templates) {
      const template = state.templates[key];
      if (template.id === targetId) {
        return null; // ルート要素なら親がないのでnullを返す
      }
      const result = findElement(template.children, targetId, template); // 親要素としてtemplateを渡す
      if (result) {
        return result;
      }
    }
  }

  return findTopParent(state, targetId);
};


// jsonの中から指定したtagNameと同じ要素を探す関数
const findElementsByTag = (json, tagName) => {
  // 結果を格納する配列
  let result = [];
  // jsonの各要素に対して
  for (let element of json) {
    // tagNameが一致する場合は結果に追加
    if (element.tagName === tagName) {
      result.push(element);
    }
    // 子要素がある場合は再帰的に探索
    if (element.children && element.children.length > 0) {
      result = result.concat(findElementsByTag(element.children, tagName));
    }
  }
  // 結果を返す
  return result;
}

// jsonとtagNameから新しいdomIdを生成する関数
const createDomId = (json, tagName, trushBoxStructure) => {
  // jsonの中から同じtagNameの要素を探す
  let elements = findElementsByTag(json, tagName);
  let trashElements = findElementsByTag(trushBoxStructure, tagName);
  trashElements = trashElements === undefined ? [] : trashElements;

  elements = elements.concat(trashElements);
  // 連番を決めるために既存のdomIdの最大値を求める
  let max = 0;
  for (let element of elements) {
    if (!element || element.domId == undefined) continue;
    // domIdがtagName+数字の形式であるかチェック
    let match = element.domId.match(new RegExp(`^${tagName}(\\d+)$`));
    if (match) {
      // 数字部分を取り出して最大値と比較
      let num = parseInt(match[1], 10);
      if (num > max) {
        max = num;
      }
    }
  }
  // 最大値に1を足して新しい連番を作る
  let newNum = max + 1;
  // tagNameと連番を結合して新しいdomIdを作る
  let newDomId = `${tagName}${newNum}`;
  // 新しいdomIdを返す
  return newDomId;
}

/**
 * 新しいtemplateIdを生成する関数
 * 
 * @param {*} elements
 * @param {*} templateId 
 */
const createTemplateId = (elements, templateId) => {

  // templateIdの文字と数値部分を抽出
  let templateIdStr;
  let templateIdNum;
  let matchResult = templateId.match(/^([^\d]+)(\d+)$/);
  if (matchResult) {
    // 文字部分を抽出
    templateIdStr = matchResult[1];
    // 数値部分を抽出して整数に変換
    templateIdNum = parseInt(matchResult[2]);
  }

  // templateIdがelementのdomIdか、element.attribute['template-id']のなかに存在すれば、templateIdの数値部分を+1する
  elements.forEach(element => {
    if (element.domId === templateIdStr + templateIdNum + '.html') {
      // 数値部分を+1
      templateIdNum++;
    } else if (element.attributes && element.attributes['template-id'] === templateIdStr + templateIdNum + '.html') {
      // 数値部分を+1
      templateIdNum++;
    }
  });

  return templateIdStr + templateIdNum;
}

/**
 * ons-splitter-sideタグの場合、collapse属性がなければデフォルト値を設定する
 * 
 * @param {*} childJson 
 */
const setDefaultAttribute = (childJson) => {
  for (const element of childJson) {
    if (element.tagName === 'ons-splitter-side') {
      // if (!element.attributes['collapse']) {
      //   element.attributes['collapse'] = 'collapse'; // デフォルト値を設定
      // }
      element.attributes = produce(element.attributes, draft => {
        if (!draft['collapse']) {
          draft['collapse'] = 'collapse'; // デフォルト値を設定
        }
      });
    }
    if (element.children && element.children.length > 0) {
      setDefaultAttribute(element.children); // 子要素に対して再帰的に処理
    }
  }
}

// IDとDOMIDを採番する
const attachIds = (fullJson, childJson, trushBoxStructure) => {

  const newChildJson = [];
  // 今回のバッチ処理内で使用された最大値をタグごとに記憶するカウンター
  const batchCounters = {};

  // 次のdomIdを取得する内部ヘルパー関数
  function getNextDomId(tagName) {
    // まだこのタグのカウンターが初期化されていなければ、現状のツリーから最大値を計算
    if (batchCounters[tagName] === undefined) {
      batchCounters[tagName] = calculateMaxIdNum(fullJson, tagName, trushBoxStructure);
    }
    // カウンターをインクリメントして返す
    batchCounters[tagName]++;
    return `${tagName}${batchCounters[tagName]}`;
  }

  // 既にdomIdが指定されている場合、カウンターをその値まで進める内部ヘルパー関数
  // (AIが domId="div10" のように手動で指定してきた場合、次の自動採番が div10 に被らないようにするため)
  function syncCounterWithExistingId(tagName, domId) {
    if (!domId) return;
    const regex = new RegExp(`^${tagName}(\\d+)$`);
    const match = domId.match(regex);
    if (match) {
      const num = parseInt(match[1], 10);
      // カウンター未初期化なら初期化
      if (batchCounters[tagName] === undefined) {
        batchCounters[tagName] = calculateMaxIdNum(fullJson, tagName, trushBoxStructure);
      }
      // 現在のカウンターより大きい値が使われていたら、そこまで進める
      if (num > batchCounters[tagName]) {
        batchCounters[tagName] = num;
      }
    }
  }

  function attachElementId(json, elmArray) {
    for (const element of json) {
      // element.children が undefined の場合も考慮
      const childrenToProcess = element.children || [];
      const newElement = {
        ...element,
        id: element == undefined || element.id === undefined ? uuidv4() : element.id,
        children: childrenToProcess.length === 0 ? [] : attachElementId(childrenToProcess, [])
      };
      elmArray.push(newElement);
    }
    return elmArray;
  }

  function attachDomId(nodes) {
    for (const element of nodes) {
      if (element.domId === undefined) {
        // domIdがない場合、カウンターを使って連番を振る
        element.domId = getNextDomId(element.tagName);
      } else {
        // domIdがある場合、カウンターの整合性をとる
        syncCounterWithExistingId(element.tagName, element.domId);
      }
      // 子要素があれば再帰的に処理
      if (element.children && element.children.length > 0) {
        attachDomId(element.children);
      }
    }
  }

  /**
   * LayoutのルートのtemplateIdを設定する
   * (この関数はロジック変更なしですが、contextのために記載)
   */
  function attachTemplateId(childJson) {
    for (const element of childJson) {
      // element.type が app ではない場合
      if (element.type !== 'app') {

        if (element.attributes['template-id'] === undefined) {
          if (element.domId && element.domId.trim() !== '') {
            // element.attributes.templateId に element.domIdから、「ons-」を抜いた値に.htmlを追加した値を設定する
            const newTemplateId = createTemplateId(fullJson, element.domId.replace(/^ons-/, ''));
            if (newTemplateId) {
              //element.attributes['template-id'] = newTemplateId + '.html';
              element.attributes = produce(element.attributes, draft => {
                draft['template-id'] = newTemplateId + '.html';
              });
            }
          }
        }
      }
    }
  }

  // 実行フロー
  attachElementId(childJson, newChildJson);

  // attachDomIdにfullJson等を渡す必要はなくなり、クロージャ内のbatchCountersとヘルパー関数を使用します
  attachDomId(newChildJson);

  attachTemplateId(newChildJson);

  // デフォルトの属性値を設定
  setDefaultAttribute(newChildJson);

  return newChildJson;
};

// スタイル文字列を正規化するヘルパー関数
// すべての空白文字（スペース、タブ、改行など）を削除し、比較に適した形式にする
function normalizeStyle(styleString) {
  if (typeof styleString !== 'string') return '';
  // 連続する空白文字をすべて削除
  return styleString.replace(/\s+/g, '');
}

/**
 * キーを指定して検索
 * 
 * @param {*} object 
 * @param {*} key 
 * @param {*} value 
 * @returns 
 */
function deepSearchByKeyValue(object, key, value) {
  const resultSet = new Set();

  function searchAttributes(obj, layerLevel = 0, topLevelParent = null, currentElement = null) {
    Object.entries(obj).forEach(([objKey, val]) => {
      if (typeof val === 'object') {
        if (objKey.indexOf(key) > -1 && JSON.stringify(val).indexOf(value) > 1) {
          let returnObj = JSON.parse(JSON.stringify(currentElement));
          returnObj['topLevelParent'] = topLevelParent;
          resultSet.add(JSON.stringify(returnObj));
        }
      } else if (typeof val === 'string') {
        // valにvalueの文字列が含まれているか
        if (objKey && objKey.toLowerCase().indexOf(key.toLowerCase()) > -1 && val && val.toLowerCase().indexOf(value.toLowerCase()) > -1) {
          //objにtopLevelParentを追加
          let returnObj = JSON.parse(JSON.stringify(currentElement));
          returnObj['topLevelParent'] = topLevelParent;
          resultSet.add(JSON.stringify(returnObj));
        }
      } else if (typeof val === 'boolean') {
        if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
          if (objKey.indexOf(key) > -1 && val === JSON.parse(value.toLowerCase())) {
            let returnObj = JSON.parse(JSON.stringify(currentElement));
            returnObj['topLevelParent'] = topLevelParent;
            resultSet.add(JSON.stringify(returnObj));
          }
        }
      }
    });
  }

  function search(obj, layerLevel = 0, topLevelParent = null, currentElement = null) {
    if (layerLevel === 1) {
      topLevelParent = obj;
    }
    if (obj instanceof Array) {
      obj.forEach(function (item) {
        search(item, layerLevel + 1, topLevelParent, item);
      });
    } else if (typeof obj === 'object' && obj !== null) {
      Object.entries(obj).forEach(([objKey, val]) => {

        switch (objKey) {
          case 'attributes':
            searchAttributes(val, layerLevel + 1, topLevelParent, obj);
            break;
          case 'domId':
          case 'explain':
          case 'tagName':
          case 'type':
          case 'text':
            if (key === 'id') key = 'domId';
            if (objKey && objKey.toLowerCase().indexOf(key.toLowerCase()) > -1 && val && val.toLowerCase().indexOf(value.toLowerCase()) > -1) {
              //objにtopLevelParentを追加
              let returnObj = JSON.parse(JSON.stringify(currentElement));
              returnObj['topLevelParent'] = topLevelParent;
              resultSet.add(JSON.stringify(returnObj));
            }
            break;

        }
        if (typeof val === 'object') {
          search(val, layerLevel + 1, topLevelParent, currentElement);
        }
      });
    }
  }

  search(object.templates);
  //search(object.trashbox);
  let retArray = [];
  resultSet.forEach(element => {
    retArray.push(JSON.parse(element));
  });
  return retArray;
}

/**
 * バリューで検索
 * @param {*} object 
 * @param {*} value 
 * @returns 
 */
function deepSearchByValue(object, value) {
  const resultSet = new Set();

  function searchAttributes(obj, layerLevel = 0, topLevelParent = null, currentElement = null) {
    Object.entries(obj).forEach(([key, val]) => {
      if (typeof val === 'object') {
        if (JSON.stringify(val).toLowerCase().indexOf(value.toLowerCase()) > 1) {
          let returnObj = JSON.parse(JSON.stringify(currentElement));
          returnObj['topLevelParent'] = topLevelParent;
          resultSet.add(JSON.stringify(returnObj));
        }
      } else if (typeof val === 'string') {
        // valにvalueの文字列が含まれているか
        if (val && val.toLowerCase().indexOf(value.toLowerCase()) > -1) {
          //objにtopLevelParentを追加
          let returnObj = JSON.parse(JSON.stringify(currentElement));
          returnObj['topLevelParent'] = topLevelParent;
          resultSet.add(JSON.stringify(returnObj));
        }
      } else if (typeof val === 'boolean') {
        if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
          if (val === JSON.parse(value.toLowerCase())) {
            let returnObj = JSON.parse(JSON.stringify(currentElement));
            returnObj['topLevelParent'] = topLevelParent;
            resultSet.add(JSON.stringify(returnObj));
          }
        }
      }
    });
  }

  function searchTemplate(obj, layerLevel = 0, topLevelParent = null, currentElement = null) {
    if (layerLevel === 1) {
      topLevelParent = obj;
    }
    if (obj instanceof Array) {
      obj.forEach(function (item) {
        searchTemplate(item, layerLevel + 1, topLevelParent, item);
      });
    } else if (typeof obj === 'object' && obj !== null) {
      Object.entries(obj).forEach(([objKey, val]) => {
        switch (objKey) {
          case 'attributes':
            searchAttributes(val, layerLevel + 1, topLevelParent, obj);
            break;
          case 'domId':
          case 'explain':
          case 'tagName':
          case 'type':
          case 'text':
            if (val && val.toLowerCase().indexOf(value.toLowerCase()) > -1) {
              //objにtopLevelParentを追加
              let returnObj = JSON.parse(JSON.stringify(currentElement));
              returnObj['topLevelParent'] = topLevelParent;
              resultSet.add(JSON.stringify(returnObj));
            }
            break;

        }
        if (typeof val === 'object') {
          searchTemplate(val, layerLevel + 1, topLevelParent, currentElement);
        }
      });
    }
  }

  searchTemplate(object.templates);

  let retArray = [];
  resultSet.forEach(element => {
    retArray.push(JSON.parse(element));
  });
  return retArray;
}

/**
 * TemplateJson内部を検索
 * 
 * @param {*} state 
 * @param {*} searchQuery 
 * @returns 
 */
export function findByValueOrKeyValue(state, searchQuery) {
  if (searchQuery.includes(":")) {
    const [key, value] = searchQuery.split(":");
    return deepSearchByKeyValue(state.templateJson, key, value);
  } else {
    return deepSearchByValue(state.templateJson, searchQuery);
  }
}

/**
 * HTMLのid属性を指定してエレメントを取得
 * 
 * @param {object} state - templateJsonを含むstateオブジェクト
 * @param {string} targetHtmlId - 検索対象のid属性値
 * @returns {object|null} - 見つかった要素、またはnull
 */
export const findElementByAttributeId = (state, targetHtmlId) => {
  function findElementRecursive(elements, id) {
    for (const element of elements) {
      if (element.attributes && element.attributes.id === id) {
        return element;
      }
      if (element.children && element.children.length > 0) {
        const result = findElementRecursive(element.children, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  let foundElement = findElementRecursive(state.templates, targetHtmlId);
  if (foundElement) return foundElement;

  foundElement = findElementRecursive(state.trashbox, targetHtmlId);
  return foundElement;
};

export const {
  loadTemplateJson, reload, addTemplate, moveToTrashbox, moveToTemplate, clearTrashbox, copyElement, insertAfter, insertAsChild, insertAsLastChild, moveAfter, moveAsChild, moveAsLastChild, updateElementStyle, updateElementAttribute, removeTagAttribute, removeElementAttribute, updateExpand, setReloadOff, setReloadOn,
  deleteTemplateByAttributeId, replaceTemplateChildren, deleteElementPermanently
} = templateJsonSlice.actions;
export const addTopLevelPage = templateJsonSlice.actions.addTemplate;
export default templateJsonSlice.reducer;